import alt from '../alt';
import filterAction from '../actions/filterAction';

class filterStore {
    constructor() {
        this.bindActions(filterAction);
        this.processing = false;
        this.iniLoadStaff = false;
        this.iniLoadCondo = false;
        this.iniLoadContractor = false;
        this.iniLoadTeamMember = false;
        this.iniLoadTeamCondo = false;
        this.iniLoadHoliday = false;
        this.staffs = [];
        this.condos = [];
        this.contractors = [];
        this.teamMember = [];
        this.teamCondo = [];
        this.holiday = {}
    }
    onEmployeeSuccess(data) {
        this.staffs = data;
        this.iniLoadStaff = true;
    }
    onCondoSuccess(data) {
        this.condos = data;
        this.iniLoadCondo = true;
    }
    onTeamCondo(data){
        this.teamCondo = data;
        this.iniLoadTeamCondo = true;
    }
    onProcessing(data) {
        this.processing = data;
    }
    onHoliday(data){
        this.holiday = data;
        this.iniLoadHoliday = true;
    }
    onUpdateSuccess(data) {
        let len = this.staffs.length;
        for (let i = 0; i < len; i++) {
            if (this.staffs[i].staffId = data.staffId) {
                this.staffs[i].role = data.role;
                this.staffs[i].userName = data.userName;
                this.staffs[i].userImage = data.userImage;
                this.staffs[i].email = data.email;
                break;
            }
        }
    }
    onUpdateCondo(data){
        let len = this.condos.length;
        for(let i = 0 ; i < len ; i++){
            if(this.condos[i].mcst == data.prevMCST){
                this.condos[i].mcst = data.newMCST;
                this.condos[i].condoName = data.condoName;
                break;
            }
        }
    }
    onContractorSuccess(data) {
        this.contractors = data;
        this.iniLoadContractor = true;
    }
    onAddSuccess(data) {
        this.staffs = this.staffs.concat(data);
    }
    onTeamMember(data){
        this.teamMember = data;
        this.iniLoadTeamMember = true;
    }
    onRemoveSuccess(data) {
        let len = this.staffs.length, pos = -1;
        for (let i = 0; i < len; i++) {
            if (this.staffs[i].staffId = data) {
                pos = i;
                break;
            }
        }
        if (pos != -1) {
            this.staffs.splice(pos, 1);
        }
    }
    onRemoveCondo(data) {
        let len = this.condos.length;
        for (let i = 0; i < len; i++) {
            if (this.condos[i].mcst = data) {
                this.condos.splice(i, 1);
                break;
            }
        }
    }
    onAddCondo(data) {
        this.condos.push(data);
    }
    onRemoveContractorSuccess(data) {
        let len = this.contractors.length;
        for (let i = 0; i < len; i++) {
            if (this.contractors[i]._id == data) {
                this.contractors.splice(i, 1);
                break;
            }
        }
    }
    onAddContractorSuccess(data) {
        this.contractors.push({
            _id: data._id,
            contractorName: data.contractorName,
            contractorEmail: data.contractorEmail,
            telephone: data.telephone
        });
    }
    onUpdateContractor(data){
        let len = this.contractors.length;
        for(let i = 0 ; i< len ; i++){
            if(this.contractors[i]._id == data){
                this.contractors[i].contractorName = data.contractorName;
                this.contractors[i].contractorEmail = data.contractorEmail;
                this.contractors[i].telephone = data.telephone;
            }
        }
    }
}
export default alt.createStore(filterStore, 'filterStore');


// WEBPACK FOOTER //
// ./app/stores/filterStore.js